/**
 * Excel Utility Functions
 *
 * Shared helper functions for working with Excel cell addresses and columns.
 */

/**
 * Get the Excel runtime, throwing an error if not available
 */
export function getExcelRuntime(): typeof window.Excel {
  const Excel = window.Excel
  if (!Excel) {
    throw new Error('Excel runtime not available')
  }
  return Excel
}

/**
 * Parse an address that may include a sheet name prefix (e.g., "Sheet1!A1:B10" or "A1:B10")
 * Returns the sheet name (if present) and the range address without the sheet prefix
 * Handles quoted sheet names (e.g., "'Orig Data'!A1:B10" → sheetName: "Orig Data")
 */
export function parseAddressWithSheet(address: string): {
  sheetName: string | null
  rangeAddress: string
} {
  const trimmed = address.trim()
  const bangIndex = trimmed.indexOf('!')

  if (bangIndex === -1) {
    // No sheet name prefix
    return { sheetName: null, rangeAddress: trimmed }
  }

  let sheetName = trimmed.substring(0, bangIndex).trim()
  const rangeAddress = trimmed.substring(bangIndex + 1).trim()

  // Strip surrounding quotes from sheet name if present
  // Excel uses quotes for sheet names with spaces or special characters
  if (
    (sheetName.startsWith("'") && sheetName.endsWith("'")) ||
    (sheetName.startsWith('"') && sheetName.endsWith('"'))
  ) {
    sheetName = sheetName.slice(1, -1)
  }

  return { sheetName, rangeAddress }
}
